const PixelHuman = ({ delay = 0 }: { delay?: number }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 64 64"
      className="pixel-human-walker"
      style={{
        imageRendering: "pixelated",
        animationDelay: `${delay}s`,
      }}
    >
      {/* 頭 */}
      <rect x="28" y="6" width="8" height="8" fill="#000" />
      {/* 体 */}
      <rect x="30" y="14" width="4" height="14" fill="#000" />
      {/* 左腕 */}
      <rect x="22" y="18" width="8" height="4" fill="#000" />
      {/* 右腕 */}
      <rect x="34" y="18" width="8" height="4" fill="#000" />
      {/* 左足 */}
      <rect className="leg left-leg" x="26" y="28" width="4" height="12" fill="#000" />
      {/* 右足 */}
      <rect className="leg right-leg" x="34" y="28" width="4" height="12" fill="#000" />
    </svg>
  );
};

const PixelHumanWalkers = () => {
  return (
    <div className="relative w-full h-16 overflow-hidden mb-4">
      <div className="walker-track">
        <PixelHuman delay={0} />
        <PixelHuman delay={0.6} />
        <PixelHuman delay={1.2} />
      </div>

      <style>
        {`
        .walker-track {
          position: absolute;
          display: flex;
          gap: 12px;
          left: -40px;
          animation: walk-across 6s linear infinite;
        }

        .pixel-human-walker {
          animation: walk-legs 0.6s steps(2) infinite;
        }

        @keyframes walk-across {
          0% { transform: translateX(0); }
          100% { transform: translateX(380%); }
        }

        @keyframes walk-legs {
          0% { transform: translateY(0); }
          50% { transform: translateY(2px); }
          100% { transform: translateY(0); }
        }
      `}
      </style>
    </div>
  );
};

export default PixelHumanWalkers;
